var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinBlackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4852",
    "data-name": "Rectangle 4852",
    width: 10.479,
    height: 17.969,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13298",
    "data-name": "Group 13298",
    transform: "translate(-488 -551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12195",
    "data-name": "Group 12195",
    transform: "translate(320.396 329.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11966",
    "data-name": "Group 11966",
    transform: "translate(167.859 221.859)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(-0.256 -0.256)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13294",
    "data-name": "Group 13294",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 499.232, 555.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12160",
    "data-name": "Group 12160",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45224",
    "data-name": "Path 45224",
    d: "M5.8,0A6.244,6.244,0,0,1,8.467.688a1.093,1.093,0,0,1,.494,1.26,3.855,3.855,0,0,1-1.431,2.5l.342,2.384c1.3.823,3.51,2.979,2.212,4.6a2.824,2.824,0,0,1-1.376.8,10.583,10.583,0,0,1-2.8.482L5.624,17.6a.383.383,0,0,1-.766,0L4.575,12.7a10.756,10.756,0,0,1-2.721-.455,2.323,2.323,0,0,1-1.762-1.4,2.392,2.392,0,0,1,.594-2.23A6.914,6.914,0,0,1,2.611,6.828l.342-2.384A3.869,3.869,0,0,1,1.609,2.387a2.327,2.327,0,0,1-.035-1.229C1.923.331,3.9.043,4.68,0Z",
    transform: "translate(0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinBlackIcon);
export default __webpack_public_path__ + "static/media/pin_black_icon.3a393c8bd8157a704f933ba4596dd967.svg";
export { ForwardRef as ReactComponent };